import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ResultList.scss';

const ResultList = ({ posts, onSort, columnTitleItems }) => (
    <table className="ResultList">
        <colgroup>
           <col style={{width: '34%'}} />
           <col style={{width: '32%'}} />
           <col style={{width: '20%'}} />
           <col style={{width: '15%'}} />
           <col style={{width: '5%'}} />
        </colgroup>
        <tbody className="ResultList__Body">
            <tr className="ResultList__Columns">
                {columnTitleItems && columnTitleItems.map((item, index) =>
                    <th key={index} className="ResultList__Column">
                        <span
                            onClick={() => onSort(item.sort)}
                            className="ResultList__ColumnTitle"
                        >{item.title}</span>
                    </th>
                )}
                <th className="ResultList__Column">
                    <span className="ResultList__ColumnTitle">{"Info"}</span>
                </th>
            </tr>
            {posts.map((item, index) =>
                <ResultItem key={index} item={item} />
            )}
        </tbody>
    </table>
);

class ResultItem extends PureComponent {
    state = {
        showDescription: false
    }

    handleShowDescription = () => {
        this.setState({ showDescription: !this.state.showDescription });
    }

    render(){
        const { item } = this.props;
        const { showDescription } = this.state;

        const classes = classNames(
            'ResultList__Row-Description',
            {[`ResultList__Row-Description--Active`]: showDescription}
        );

        const showDescriptionClasses = classNames(
            'ResultList__ShowDescription',
            {[`ResultList__ShowDescription--Active`]: showDescription}
        );

        return [
            <tr
                className="ResultList__Row"
                onClick={this.handleShowDescription}
                key={`${item.Class}`}
            >
                <td className="ResultList__RowItem">{item.CertificateOwner}</td>
                <td className="ResultList__RowItem">{item.ServiceAreaProductName}</td>
                <td className="ResultList__RowItem">{item.ProductDesignation}</td>
                <td className="ResultList__RowItem">{item.Class}</td>
                <td className="ResultList__RowItem">
                    <span className={showDescriptionClasses}/>
                </td>
            </tr>,
            <tr className={classes} key={`${item.Class}-detail`}>
                <ResultDetail {...item} />
            </tr>
        ]
    }
}

const ResultDetail = ({
    CertificateNumber,
    CertificateOwner,
    CertificateType,
    Class,
    ValidTo,
    RegulationDestination,
    Regulation,
    Other,
    PostAddress,
    PostPostal,
    PostCity,
    Telephone,
    Fax,
    Email,
    BranchAddress,
    BranchCity
}) => (
    <td colSpan="5" className="ResultList__RowItem ResultList__RowItem--Description">
        <h4 className="ResultList__Description-Title">{"Detaljerad information"}</h4>
        {CertificateNumber && <p className="ResultList__Description-Info">{'Cert nr'}: {CertificateNumber}</p>}
        {CertificateOwner && <p className="ResultList__Description-Info">{'Innehavare'}: {CertificateOwner}</p>}
        {CertificateType && <p className="ResultList__Description-Info">{'Typ'}: {CertificateType}</p>}
        {Class && <p className="ResultList__Description-Info">{'Klass'}: {Class}</p>}
        {ValidTo && <p className="ResultList__Description-Info">{'Giltighetstid'}: {ValidTo}</p>}
        {RegulationDestination && <p className="ResultList__Description-Info">{'Regelverk'}: {RegulationDestination}</p>}
        {Regulation && <p className="ResultList__Description-Info">{'Regelverksnamn'}: {Regulation}</p>}
        {Other && <p className="ResultList__Description-Info">{'Övrigt'}: {Other}</p>}

        <h4 className="ResultList__Description-Title">{"Kontakt"}</h4>
        {PostAddress && <p className="ResultList__Description-Info">{'Adress'}: {PostAddress}</p>}
        {PostPostal && <p className="ResultList__Description-Info">{'Post-nr Ort'}: {PostPostal}, {PostCity}</p>}
        {Telephone && <p className="ResultList__Description-Info">{'Telefon'}: {Telephone}</p>}
        {Fax && <p className="ResultList__Description-Info">{'Fax'}: {Fax}</p>}
        {Email && <p className="ResultList__Description-Info">{'Epost'}: {Email}</p>}
        {BranchAddress && <p className="ResultList__Description-Info">{'Verksamhetsadress'}: {BranchAddress}</p>}
        {BranchCity && <p className="ResultList__Description-Info">{'Ort'}: {BranchCity}</p>}
    </td>
)

ResultList.propTypes = {
    posts: PropTypes.array.isRequired,
};

ResultList.defaultProps = {
    posts: []
};

export default ResultList;
